import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import Swal from 'sweetalert2';
import { ProcessingOrders } from 'src/app/models/supplier-portal/supplier/supplierOrdersProcessing.models';
import { OrderProcessingService } from 'src/app/services/portal-supplier/order-processing.service';
import { ManufacturerPopoversService } from 'src/app/services/shared/manufacturer-popovers.service';

@Component({
  selector: 'app-check-order-upload',
  standalone: false,
  templateUrl: './check-order-upload.component.html',
  styleUrls: ['./check-order-upload.component.scss'],
})
export class CheckOrderUploadComponent implements OnInit {
  @ViewChild('certificateFileInput')
  private certificateFileInput?: ElementRef<HTMLInputElement>;

  @Input({ required: true }) public articleCode = -1;
  @Input()
  public batchToAddFileTo: Partial<ProcessingOrders.IProductBatch> | null =
    null;

  @Output() public readonly goToList = new EventEmitter<boolean>();

  public documentToAdd: ProcessingOrders.ICertificateFile | null = null;
  public uploadedFileName = '';
  private readonly orderServ = inject(OrderProcessingService);
  private popoverServ = inject(ManufacturerPopoversService);
  public mServ = inject(ManufacturerPopoversService);
  ngOnInit(): void {
    console.log('batch is ', this.batchToAddFileTo);
  }
  public uploadCertificate(): void {
    this.certificateFileInput?.nativeElement.click();
  }

  public onCertificateSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) {
      return;
    }

    const batchInfo = this.batchToAddFileTo as
      | (Partial<ProcessingOrders.IProductBatch> & { result_id?: number })
      | null;

    const certificationBatchId =
      batchInfo?.supplier_certificate_batch_id;
    if (!certificationBatchId) {
      this.mServ.errorSwal('Batch non disponibile per il caricamento del certificato.');
      input.value = '';
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const fileContent = reader.result?.toString() ?? '';
      const base64Content = fileContent.includes(',')
        ? fileContent.split(',')[1]
        : fileContent;

      this.documentToAdd = {
        certification_batch_id: certificationBatchId,
        certification_file: base64Content,
        certification_title: file.name,
        certification_file_name: file.name,
      };

      this.orderServ.putCertificationFile(this.documentToAdd).subscribe({
        next: async (response) => {
          if (!response || response instanceof HttpErrorResponse) {
            this.mServ.errorSwal('Errore durante il caricamento del certificato.');
            return;
          }

          const requestSucceeded =
            !('success' in response) || response.success === true;

          if (!requestSucceeded) {
            this.mServ.errorSwal('Errore durante il caricamento del certificato.');
            return;
          }

          const uploadedFile =
            'data' in response
              ? (response.data as ProcessingOrders.IFile | null)
              : response;

          this.uploadedFileName =
            uploadedFile?.certification_title ?? file.name;
          const isConfirm = await this.popoverServ.goToDocumentsList();
          // Swal.fire({
          //   icon: 'success',
          //   title: 'Successo',
          //   text: 'Certificato caricato con successo.',
          // });

          this.seeList(isConfirm)
        },
        error: () => {
          this.mServ.errorSwal('Errore durante il caricamento del certificato.');
        },
      });
    };

    reader.onerror = () => {
      this.mServ.errorSwal('Impossibile leggere il file selezionato.');
    };

    reader.readAsDataURL(file);
    input.value = '';
  }

  public seeList(next: boolean): void {
    // event.stopPropagation();
    this.goToList.emit(next);
    console.log('reviewing batches', event);
  }
}
